module.exports = __webpack_public_path__ + "static/media/no_image.29a5956e.png";